import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateThreads = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 276,
	height: 276,
	viewBox: "0 0 276 276",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7617_163837)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M133.237 243.908C187.311 243.908 231.146 200.072 231.146 145.998C231.146 91.9248 187.311 48.0894 133.237 48.0894C79.1635 48.0894 35.3281 91.9248 35.3281 145.998C35.3281 200.072 79.1635 243.908 133.237 243.908Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M201.809 42.5706L206.678 34.1112C207.172 33.2496 206.557 32.1772 205.563 32.1711L196.073 32.0928C195.085 32.0868 194.453 33.1412 194.923 34.0028L199.544 42.5405C200.026 43.4322 201.303 43.4503 201.803 42.5706H201.809Z",
				fill: "#FFE3E0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.4639 63.5081L40.811 70.7925C39.5276 71.5336 37.9189 70.6118 37.9069 69.1296L37.7984 54.9342C37.7864 53.4581 39.3589 52.5121 40.6604 53.2171L53.4217 60.1279C54.7533 60.851 54.7774 62.7549 53.4639 63.5141V63.5081Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M210.394 212.529L223.998 216.47C225.417 216.883 225.868 218.673 224.812 219.704L214.97 229.332C213.918 230.359 212.154 229.882 211.762 228.467L208 214.898C207.6 213.441 208.95 212.107 210.399 212.525L210.394 212.529Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M110.495 123.791L128.137 124.136C130.072 124.174 130.938 126.58 129.472 127.843L111.88 142.997C111.263 143.528 110.437 143.648 109.715 143.452C108.99 143.255 108.423 142.756 108.273 142.106C108.245 141.984 108.228 141.856 108.211 141.714C108.195 141.576 108.179 141.421 108.152 141.268L105.958 129.11C105.452 126.303 107.642 123.735 110.495 123.791Z",
				fill: "white",
				stroke: "#F4F5F7",
				strokeWidth: .602518
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 93.319,
				y: 83.2571,
				width: 145.809,
				height: 44.5863,
				rx: 8.73651,
				transform: "rotate(3.6549 93.319 83.2571)",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 93.319,
				y: 83.2571,
				width: 145.809,
				height: 44.5863,
				rx: 8.73651,
				transform: "rotate(3.6549 93.319 83.2571)",
				stroke: "#F4F5F7",
				strokeWidth: .602518
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_7617_163837",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 98,
				y: 90,
				width: 21,
				height: 20,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M107.757 109.913C113.308 110.268 118.093 106.112 118.443 100.632C118.793 95.1512 114.576 90.4208 109.024 90.0662C103.472 89.7116 98.6879 93.8669 98.3378 99.3475C97.9877 104.828 102.205 109.558 107.757 109.913Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_7617_163837)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M107.757 109.913C113.308 110.268 118.093 106.112 118.443 100.632C118.793 95.1512 114.576 90.4208 109.024 90.0662C103.472 89.7116 98.6879 93.8669 98.3378 99.3475C97.9877 104.828 102.205 109.558 107.757 109.913Z",
						fill: "#002F75"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M108.278 101.747C110.504 101.889 112.422 100.223 112.562 98.0258C112.703 95.8287 111.012 93.9323 108.786 93.7901C106.561 93.648 104.643 95.3138 104.502 97.511C104.362 99.7081 106.052 101.604 108.278 101.747Z",
						fill: "#9EC5FF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M107.423 115.135C111.307 115.383 114.655 112.476 114.9 108.642C115.145 104.807 112.194 101.498 108.31 101.25C104.426 101.002 101.078 103.909 100.833 107.743C100.588 111.578 103.539 114.887 107.423 115.135Z",
						fill: "#9EC5FF"
					})
				]
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 126.408,
				y: 92.4043,
				width: 55.4316,
				height: 7.23021,
				rx: 3.61511,
				transform: "rotate(3.6549 126.408 92.4043)",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 125.653,
				y: 104.22,
				width: 107.851,
				height: 6.02518,
				rx: 3.01259,
				transform: "rotate(3.6549 125.653 104.22)",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 125.038,
				y: 113.84,
				width: 96.4028,
				height: 6.02518,
				rx: 3.01259,
				transform: "rotate(3.6549 125.038 113.84)",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 205.549,
				y: 68.8601,
				width: 26.7611,
				height: 26.7611,
				rx: 3.34513,
				transform: "rotate(3.82491 205.549 68.8601)",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M222.727 75.0373C225.031 75.1914 226.774 77.1844 226.62 79.4886L226.282 84.5466C226.128 86.8505 224.135 88.593 221.831 88.439L220.975 88.3818L219.72 90.3121C218.65 91.9564 216.192 91.7919 215.351 90.02L214.363 87.9398L213.508 87.8826C211.204 87.7285 209.461 85.7363 209.614 83.4323L209.952 78.3742C210.107 76.07 212.1 74.3268 214.404 74.4809L222.727 75.0373ZM214.264 76.567C213.112 76.49 212.116 77.3616 212.039 78.5137L211.7 83.5717C211.624 84.7236 212.495 85.7194 213.647 85.7964L215.481 85.919C215.632 85.9291 215.766 86.0209 215.831 86.1577L217.239 89.1235C217.379 89.4185 217.788 89.4457 217.967 89.1722L219.757 86.4202C219.839 86.2933 219.985 86.2202 220.136 86.2302L221.97 86.3529C223.122 86.4298 224.119 85.559 224.196 84.4072L224.534 79.3491C224.611 78.1971 223.74 77.2006 222.588 77.1235L214.264 76.567ZM218.076 82.0777C218.652 82.1164 219.087 82.6141 219.049 83.19C219.01 83.7659 218.513 84.2022 217.937 84.1639L214.031 83.9028C213.455 83.8642 213.02 83.3655 213.058 82.7895C213.097 82.2135 213.595 81.7782 214.171 81.8166L218.076 82.0777ZM222.189 79.2149C222.765 79.2534 223.202 79.7513 223.163 80.3272C223.125 80.9033 222.626 81.3395 222.05 81.301L214.24 80.7789C213.664 80.7403 213.229 80.2416 213.267 79.6656C213.306 79.0897 213.804 78.6543 214.38 78.6927L222.189 79.2149Z",
				fill: "#1950A3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M133.761 213.142L133.072 197.793L113.366 198.677L130.736 214.557C131.925 215.643 133.833 214.749 133.761 213.142Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.314 161.436L46.767 166.08C41.7806 166.303 37.9196 170.527 38.1432 175.513L39.1109 197.092C39.3345 202.078 43.5581 205.939 48.5445 205.716L152.092 201.072C157.078 200.848 160.939 196.625 160.715 191.638L159.748 170.06C159.524 165.073 155.3 161.212 150.314 161.436Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask1_7617_163837",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 44,
				y: 171,
				width: 22,
				height: 21,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M55.2981 191.469C60.943 191.215 65.314 186.434 65.0608 180.789C64.8077 175.144 60.0263 170.773 54.3813 171.026C48.7363 171.279 44.3654 176.061 44.6185 181.706C44.8717 187.351 49.6531 191.722 55.2981 191.469Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask1_7617_163837)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M55.2981 191.469C60.943 191.215 65.314 186.434 65.0608 180.789C64.8077 175.144 60.0263 170.773 54.3813 171.026C48.7363 171.279 44.3654 176.061 44.6185 181.706C44.8717 187.351 49.6531 191.722 55.2981 191.469Z",
						fill: "#002F75"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M54.9207 183.057C57.1837 182.956 58.936 181.039 58.8345 178.776C58.733 176.513 56.8162 174.76 54.5532 174.862C52.2901 174.963 50.5378 176.88 50.6393 179.143C50.7408 181.406 52.6577 183.159 54.9207 183.057Z",
						fill: "#9EC5FF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M55.539 196.847C59.4885 196.67 62.5465 193.325 62.3694 189.376C62.1923 185.426 58.8471 182.368 54.8976 182.545C50.9482 182.722 47.8902 186.068 48.0673 190.017C48.2444 193.966 51.5896 197.024 55.539 196.847Z",
						fill: "#9EC5FF"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M73.8892 183.496L131.45 180.914",
				stroke: "#9EC5FF",
				strokeWidth: 3.61511,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M73.8892 172.65L116.065 170.759",
				stroke: "#9EC5FF",
				strokeWidth: 5.42266,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M74.3999 193.673L113.572 191.916",
				stroke: "#9EC5FF",
				strokeWidth: 3.61511,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7617_163837",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 205.344,
			height: 211.815,
			fill: "white",
			transform: "translate(35.3281 32.0925)"
		})
	}) })]
});
export default SvgEmptyStateThreads;
